import { URL_REPLACEMENT } from '$const';
import { get } from '~services/api/methods';

export async function getExportTicket() {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/o2e/api/export/ticket`;
  const response = await get(requestUrl);
  return response;
}

export async function getExportJob(jobId: number, clientId: number, exportTicket: string) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/o2e/api/export/job/${jobId}/${clientId}/${exportTicket}`;
  const response = await get(requestUrl);
  return response;
}

export async function getExportJobMyFiles(jobId: number, clientId: number) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/o2e/api/export_myfiles/job/${jobId}/${clientId}`;
  const response = await get(requestUrl);
  return response;
}

export async function getExportDocument(documentId: number, clientId: number, formatId: number, exportTicket: string) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/o2e/api/export/document/${documentId}/${clientId}/${formatId}/${exportTicket}`;
  const response = await get(requestUrl);
  return response;
}

export async function getExportDocumentMyFiles(documentId: number, clientId: number, formatId: number) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/o2e/api/export_myfiles/document/${documentId}/${clientId}/${formatId}`;
  const response = await get(requestUrl);
  return response;
}

export async function getExportStatus(exportTicket: string) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/o2e/api/export/status/${exportTicket}`;
  const response = await get(requestUrl);
  return response;
}
